import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row, UncontrolledDropdown } from "reactstrap";
import MenuTap from "../../../components/common/menu-tap";
import BreadCrumb from "../../../components/common/bread-crumb";
import TableModify from "../../../components/common/table-modify";
import * as Yup from "yup";
import { useFormik } from "formik";
import ConfigData from '../../../config.json';
import axios from "axios";
import Swal from "sweetalert2";
import { handlerRespError } from "../../../components/utility/handler_resp";
import { useHistory } from "react-router-dom";
const LevelEducationList = () => {
    const [isShowModal, setIsShowModal] = useState();
    const [dataTable, setDataTable] = useState([]);
    const [dataDetail, setDataDetail] = useState({
        id: 0,
        name: "",
        remark: ""
    });
    const history = useHistory();

    useEffect(() => {
        LoadDataTable();
    }, []);
    const column = [
        {
            key: "id",
            name: <span className='font-weight-bold fs-13'>No.</span>,
            cell: (row, index) => index+1,
            width: "10%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: false
        },
        {
            key: "name",
            name: <span className='font-weight-bold fs-13'>Name</span>,
            cell: (row, index) => row.name,
            width: "80%",
            classHeader: "text-start",
            classBody: "text-start",
            sortable: true
        },
        {
            key: "action",
            name: <span className='font-weight-bold fs-13'></span>,
            cell: (row, index) => {
                return(
                    <UncontrolledDropdown key={index}>
                        <DropdownToggle tag="button" className="btn" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i className="ri-more-2-fill"></i></DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                            <li>
                                <DropdownItem onClick={() => onClickUpdate(row)}>
                                    <i className="ri-pencil-fill"></i> Edit
                                </DropdownItem>
                            </li>
                            <li>
                                <DropdownItem onClick={() => onClickDelete(row.id)}>
                                    <i className="ri-delete-bin-line"></i> Delete
                                </DropdownItem>
                            </li>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                )
            },
            width: "10%",
            classHeader: "text-start",
            classBody: "text-end",
            sortable: false
        }
    ];
    
    const onClickAdd = () => {
        validation.resetForm();
        setDataDetail({
            id: 0,
            code: "",
            name: "",
            remark: ""
        });
        setIsShowModal(!isShowModal);
    };

    const onClickUpdate= (data) => {
        validation.resetForm();
        setDataDetail({
            id: data.id,
            code: data.code,
            name: data.name,
            remark: data.remark
        });
        setIsShowModal(!isShowModal);
    };

    const onClickDelete = (id) => {
        Swal.fire({
            title: 'Are you sure ?',
            text: 'Once you delete, you can not undo it!',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            confirmButtonColor: '#dc3741',
        }).then((result) => {
            if(result.isConfirmed){
                DeleteLevelEducation(id);
            }
        });
    };

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataDetail.id || 0,
            name:  dataDetail.name || "",
            remark: dataDetail.remark || "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Please enter a Name"),
        }),
        onSubmit: (values) => {
            if(values.id > 0){
                UpdateLevelEducation(values);
            }else{
                AddLevelEducation(values);
            }
        }
    });

    const LoadDataTable = () => {
        let url = ConfigData.API_URL + "level-education/?status=1";
        let token = "Bearer " + sessionStorage.getItem("token");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                setDataTable(respData.data);
            }
        })
        .catch(error => {
            handlerRespError(error, history);
        });
    };

    const AddLevelEducation = (data) => {
        let url = ConfigData.API_URL + "level-education/";
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        axios.post(url, data, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataTable();
                setIsShowModal(!isShowModal);
                Swal.fire({
                    icon: 'success',
                    title: 'Add data success !',
                    confirmButtonColor: '#3085d6',
                });
            }
        })
        .catch(error => {
            handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to add data.',
                confirmButtonColor: '#3085d6',
            });
        });
    };

    const UpdateLevelEducation = (data) => {
        let url = ConfigData.API_URL + "level-education/" + data.id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        axios.put(url, data, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataTable();
                setIsShowModal(false);
                Swal.fire({
                    icon: 'success',
                    title: 'Edit data success !',
                    confirmButtonColor: '#3085d6',
                });
            }
        })
        .catch(error => {
            handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to edit data.',
                confirmButtonColor: '#3085d6',
            });
        });
    };

    const DeleteLevelEducation = (id) => {
        let url = ConfigData.API_URL + "level-education/" + id;
        let token = "Bearer " + sessionStorage.getItem("token");
        let userId = sessionStorage.getItem("uid");
        axios.delete(url, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true){
                LoadDataTable();
                Swal.fire({
                    icon: 'success',
                    title: 'Delete data success !',
                    confirmButtonColor: '#3085d6',
                });
            }
        })
        .catch(error => {
            handlerRespError(error, history);
            Swal.fire({
                icon: 'error',
                title: 'Failed to delete data.',
                confirmButtonColor: '#3085d6',
            });
        });
    };

    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Education" pageTitle="Data setting" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <CardBody>
                                    <MenuTap type="education" idActive="1" />
                                    <TableModify data={dataTable} column={column} rowPerPage={25} onClickAdd={onClickAdd} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            {/* Modal Add and Edit */}
            <Modal id="modalLevelEducation"
                isOpen={isShowModal}
                toggle={() => { setIsShowModal(!isShowModal); }}
                backdrop={'static'}
                centered
            >
                <ModalHeader id="modalLevelEducationHeader" 
                    className="modal-title"
                    toggle={() => { setIsShowModal(!isShowModal); }}
                >
                    {(dataDetail.id <= 0) ? "Create level education" : "Edit level education"}
                </ModalHeader>
                <ModalBody>
                    <Form className="needs-validation"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="txtName">Name</Label>
                                    <Input id="txtName" 
                                        name="name"
                                        placeholder="Name"
                                        type="text"
                                        className="from-control"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.name || ""}
                                        invalid={ validation.touched.name && validation.errors.name ? true : false }
                                    />
                                    { validation.touched.name && validation.errors.name ? 
                                        ( <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> ) : false 
                                    }
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <FormGroup className="mb-3">
                                    <Label htmlFor="txtRemark">Remark</Label>
                                    <Input id="txtRemark" 
                                        name="remark"
                                        placeholder="Remark"
                                        type="textarea"
                                        className="from-control"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.remark || ""}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="12">
                                <Button color="primary" type="button" onClick={() => setIsShowModal(false) } >
                                    Close
                                </Button>
                                <Button className="float-end" color="success" type="submit">
                                    Save
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}

export default LevelEducationList;